import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Segment, SegmentIcon, SegmentWidth } from './vertical-segments.model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'cbre-vertical-segments',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './vertical-segments.component.scss',
  template: `
    <div class="vs__elevator-container">
      @for (segIndex of segmentCountArr; track segIndex) {
        <div
          [ngClass]="'vs__elevator-wrapper vs__elevator-wrapper--' + segmentWidth()"
          >
          <div
          [ngClass]="
            !segmentsData()[segIndex]?.hide
              ? 'vs__elevator vs__elevator--' + segmentsData()[segIndex]?.variant
              : 'vs__elevator'
          "
          ></div>
          @if (segmentsData()[segIndex]?.icon != null) {
            @switch (segmentsData()[segIndex].icon) {
              @case (segmentIconOpts.start) {
                <div
                  class="vs__elevator-icon vs__elevator-icon-start"
                  [ngClass]="'vs__elevator-icon-start--' + segmentsData()[segIndex]?.variant"
                  >
                  <span class="icon-ev-start"></span>
                </div>
              }
              @default {
                <div class="vs__elevator-icon vs__elevator-icon-stop">
                  <mat-icon svgIcon="elevator" aria-hidden="false"></mat-icon>
                </div>
              }
            }
          }
        </div>
      }
    </div>
    `,
  imports: [CommonModule, MatIconModule],
})
export class VerticalSegmentsComponent {
  /**
   * Data for the segments is a map where the key is the index of the segment that should be displayed and the value is the segment data
   */
  readonly segmentsData = input<{ [key: number]: Segment }>({});
  /**
   * The number of segments to display
   */
  readonly segmentCount = input<number>();

  /**
   * The width of the segments
   */
  readonly segmentWidth = input<SegmentWidth>(SegmentWidth.Thick);

  public segmentIconOpts = SegmentIcon;
  public segmentCountArr: number[] = [];

  constructor() {
    effect(() => {
      const count = this.segmentCount();
      if (count != null) {
        this.segmentCountArr = Array.from({ length: count }, (_, i) => i);
      }
    });
  }
}
